/**
 * Draw an arrowhead on a line on an HTML5 canvas.
 *
 * Downloaded from: https://gist.github.com/jwir3/d797037d2e1bf78a9b04838d73436197
 * and converted to typescript and our code style.
 *
 */
export const drawArrowHead = (
  context: CanvasRenderingContext2D,
  from: { x: number; y: number },
  to: { x: number; y: number },
  radius: number,
) => {
  const xCenter = to.x;
  const yCenter = to.y;
  let angle;
  let x;
  let y;
  context.beginPath();
  angle = Math.atan2(to.y - from.y, to.x - from.x);
  x = radius * Math.cos(angle) + xCenter;
  y = radius * Math.sin(angle) + yCenter;
  context.moveTo(x, y);
  angle += (1.0 / 3.0) * (2 * Math.PI);
  x = radius * Math.cos(angle) + xCenter;
  y = radius * Math.sin(angle) + yCenter;
  context.lineTo(x, y);
  angle += (1.0 / 3.0) * (2 * Math.PI);
  x = radius * Math.cos(angle) + xCenter;
  y = radius * Math.sin(angle) + yCenter;
  context.lineTo(x, y);
  context.closePath();
  context.fill();
};
